namespace RioERP.Users {
    export interface BrandAmbassadorRow {
        Id?: number;
        Name?: string;
        Description?: string;
        Email?: string;
        AlternateEmail?: string;
        Mobile?: string;
        AlternateMobile?: string;
        Address?: string;
        City?: string;
        StateId?: number;
        UserId?: number;
        Gstin?: string;
        Pan?: string;
        GstCertificate?: string;
        BankName?: string;
        BankAccountType?: number;
        BankAccountName?: string;
        BankAccountNo?: string;
        BankIfscCode?: string;
        Pincode?: number;
        IsActive?: boolean;
        CustomerId?: number;
        DiscountCoupon?: string;
        StateName?: string;
        StateIsActive?: boolean;
        StateInsertUserId?: number;
        StateInsertDate?: string;
        StateUpdateUserId?: number;
        StateUpdateDate?: string;
        StateIsHomeState?: boolean;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserMobilePhoneNumber?: string;
        UserMobilePhoneVerified?: boolean;
        UserTwoFactorAuth?: number;
        UserSecretkey?: string;
        UserAllowedIps?: string;
        UserXapikey?: string;
        UserXapisecret?: string;
        UserCcEmails?: string;
        CustomerName?: string;
        CustomerEmailId1?: string;
        CustomerEmailId2?: string;
        CustomerMobile1?: string;
        CustomerMobile2?: string;
        CustomerIsActive?: boolean;
        CustomerInsertUserId?: number;
        CustomerInsertDate?: string;
        CustomerUpdateUserId?: number;
        CustomerUpdateDate?: string;
        CustomerECustomerType?: number;
        CustomerGstin?: string;
        CustomerCouponCode?: string;
        CustomerAttemptId?: number;
        CustomerCourseId?: number;
        CustomerLevelId?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace BrandAmbassadorRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Users.BrandAmbassador';
        export const lookupKey = 'Users.BrandAmbassador';

        export function getLookup(): Q.Lookup<BrandAmbassadorRow> {
            return Q.getLookup<BrandAmbassadorRow>('Users.BrandAmbassador');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Description = "Description",
            Email = "Email",
            AlternateEmail = "AlternateEmail",
            Mobile = "Mobile",
            AlternateMobile = "AlternateMobile",
            Address = "Address",
            City = "City",
            StateId = "StateId",
            UserId = "UserId",
            Gstin = "Gstin",
            Pan = "Pan",
            GstCertificate = "GstCertificate",
            BankName = "BankName",
            BankAccountType = "BankAccountType",
            BankAccountName = "BankAccountName",
            BankAccountNo = "BankAccountNo",
            BankIfscCode = "BankIfscCode",
            Pincode = "Pincode",
            IsActive = "IsActive",
            CustomerId = "CustomerId",
            DiscountCoupon = "DiscountCoupon",
            StateName = "StateName",
            StateIsActive = "StateIsActive",
            StateInsertUserId = "StateInsertUserId",
            StateInsertDate = "StateInsertDate",
            StateUpdateUserId = "StateUpdateUserId",
            StateUpdateDate = "StateUpdateDate",
            StateIsHomeState = "StateIsHomeState",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            UserSource = "UserSource",
            UserLastDirectoryUpdate = "UserLastDirectoryUpdate",
            UserUserImage = "UserUserImage",
            UserInsertDate = "UserInsertDate",
            UserInsertUserId = "UserInsertUserId",
            UserUpdateDate = "UserUpdateDate",
            UserUpdateUserId = "UserUpdateUserId",
            UserIsActive = "UserIsActive",
            UserMobilePhoneNumber = "UserMobilePhoneNumber",
            UserMobilePhoneVerified = "UserMobilePhoneVerified",
            UserTwoFactorAuth = "UserTwoFactorAuth",
            UserSecretkey = "UserSecretkey",
            UserAllowedIps = "UserAllowedIps",
            UserXapikey = "UserXapikey",
            UserXapisecret = "UserXapisecret",
            UserCcEmails = "UserCcEmails",
            CustomerName = "CustomerName",
            CustomerEmailId1 = "CustomerEmailId1",
            CustomerEmailId2 = "CustomerEmailId2",
            CustomerMobile1 = "CustomerMobile1",
            CustomerMobile2 = "CustomerMobile2",
            CustomerIsActive = "CustomerIsActive",
            CustomerInsertUserId = "CustomerInsertUserId",
            CustomerInsertDate = "CustomerInsertDate",
            CustomerUpdateUserId = "CustomerUpdateUserId",
            CustomerUpdateDate = "CustomerUpdateDate",
            CustomerECustomerType = "CustomerECustomerType",
            CustomerGstin = "CustomerGstin",
            CustomerCouponCode = "CustomerCouponCode",
            CustomerAttemptId = "CustomerAttemptId",
            CustomerCourseId = "CustomerCourseId",
            CustomerLevelId = "CustomerLevelId",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
